import { render, staticRenderFns } from "./TableCopyYAxisField.vue?vue&type=template&id=0a462b0e&"
import script from "./TableCopyYAxisField.vue?vue&type=script&lang=js&"
export * from "./TableCopyYAxisField.vue?vue&type=script&lang=js&"
import style0 from "./TableCopyYAxisField.vue?vue&type=style&index=0&id=0a462b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports